import { Controls } from './controls.component';

export * from './controls.component';
export default Controls;

Controls.define('der-ui-controls');

declare global {
    interface HTMLElementTagNameMap {
        'der-ui-controls': Controls;
    }
}
